import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Statement from "./pages/statement";
import AppContainer from "./pages/cnp";
import NotFound from "./pages/404";
import { setLoggedInMerchant } from "./redux/reducer/authentication";
import Error from "./pages/error";
import BaseContainer from "./components/BaseContainer";
import History from "./pages/history";

const App = () => {

  const loggedInMerchant = useSelector(
    // @ts-ignore
    state => state.authenticationReducer.loggedInMerchant,
  );
  if (!loggedInMerchant) {
    const dispatch = useDispatch();
    dispatch(setLoggedInMerchant());
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<BaseContainer />}>
          <Route path="/" element={<History />} />
          <Route path="cnp" element={<AppContainer />} />
        </Route>
        <Route path="/statement/:statement" element={<Statement />} />
        <Route path="/error" element={<Error />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
